import React, { useEffect, useState } from "react";
import { BlockPreviewRect, previewBigEnough } from "../blocks/BlockPreview";
import { useAtom } from "jotai";
import { currentUserAtom, useOnlines } from "../jotai/atoms";
import useSound from "use-sound";

import { usePreviews } from "../roomservice/presences";
import { pixelToGridSize } from "../utils/gridPosition";

const tickSfx = require("../assets/sounds/tick.wav").default;
const tockSfx = require("../assets/sounds/tock.wav").default;

function PreviewList() {
  const [currentUser] = useAtom(currentUserAtom);
  const onlines = useOnlines();
  const [previews] = usePreviews();
  const [playTick] = useSound(tickSfx, {
    volume: 0.05,
  });
  const [playTock] = useSound(tockSfx, { volume: 0.05 });

  const number_people = Object.keys(previews).filter((uid: string) => {
    let { position } = previews[uid];
    return position.x >= 0 && position.y >= 0;
  }).length;
  const [prevNumber, setPrevNumber] = useState(number_people);
  useEffect(() => {
    if (number_people > prevNumber) {
      playTick();
    } else if (number_people < prevNumber) {
      playTock();
    }
    setPrevNumber(number_people);
  }, [number_people, playTick, playTock, prevNumber]);

  return onlines ? (
    <ul>
      {Object.keys(previews).map((uid: string) => {
        let { position, size } = previews[uid];
        let gridSize = pixelToGridSize(size);
        if (currentUser?.id === uid) {
          return null;
        }

        const bigEnough = previewBigEnough(gridSize);
        // should import this from block preview
        const isText =
          bigEnough && (gridSize.height <= 4 || gridSize.width <= 4);

        return (
          <li key={uid}>
            <BlockPreviewRect
              isDragging={size.width > 0}
              isText={isText}
              bigEnough={previewBigEnough(gridSize)}
              position={position}
              size={gridSize}
              userId={uid}
            />
          </li>
        );
      })}
    </ul>
  ) : (
    <span>No previews</span>
  );
}

export default PreviewList;
